import React, { useContext, useEffect, useState } from 'react';

import cx from 'classnames';
import { useTrackersDefaultCurriculumData } from 'sdk';

import CreateMathV2 from 'pages/Teachers/Assignments/CreateMathV2';
import { useMixpanelPageOpenTrack } from 'utils/integrations/mixpanel';
import { trackMixpanelPageView } from 'utils/integrations/mixpanel';

import AcceleratedCurriculumSwitch from './components/AcceleratedCurriculumSwitch';
import CurriculumIndex from 'components/CurriculumIndex';
import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const TeacherAssignmentCreateV2 = ({ onWidthChange }) => {
  const [isFlowSelected, setIsFlowSelected] = useState(false);
  const [isCreateTemplateSelected, setIsCreateTemplateSelected] =
    useState(false);

  const [isAcceleratedCurriculum, setIsAcceleratedCurriculum] = useState(false);

  const { user } = useContext(UserContext);

  const {
    data: trackersDefaultCurriculumData,
    isLoading: isLoadingDefaultData
  } = useTrackersDefaultCurriculumData();

  useEffect(() => {
    if (!trackersDefaultCurriculumData) return;

    if (trackersDefaultCurriculumData['is_accelerated'])
      setIsAcceleratedCurriculum(true);
    else setIsAcceleratedCurriculum(false);
  }, [trackersDefaultCurriculumData]);

  useEffect(() => {
    trackMixpanelPageView(user.id, {
      feature: 'create',
      view: 'type'
    });
  }, [user]);

  useMixpanelPageOpenTrack('Teacher opened Create page');

  useEffect(() => {
    if (typeof onWidthChange === 'function') {
      const isSelectFlow = !isFlowSelected;

      onWidthChange(isSelectFlow);
    }
  }, [isFlowSelected, onWidthChange]);

  return (
    <div
      className={cx(styles.container, {
        [styles.newFlowContainer]: true,
        [styles.nonMathSpacing]: false
      })}
    >
      {isFlowSelected && isCreateTemplateSelected && (
        <div className={styles.buttonContainer}>
          <button
            type="button"
            className={styles.backButton}
            onClick={() => {
              setIsFlowSelected(false);
              setIsCreateTemplateSelected(false);
            }}
          >
            ← BACK: CHOOSE TYPE
          </button>
        </div>
      )}

      {!isFlowSelected && <CreateMathV2 />}

      {isFlowSelected && isCreateTemplateSelected && (
        <>
          <AcceleratedCurriculumSwitch
            isAcceleratedCurriculum={isAcceleratedCurriculum}
            setIsAcceleratedCurriculum={setIsAcceleratedCurriculum}
          />
          <CurriculumIndex
            isAcceleratedCurriculum={isAcceleratedCurriculum}
            defaultData={trackersDefaultCurriculumData}
            isLoadingDefaultData={isLoadingDefaultData}
          />
        </>
      )}
    </div>
  );
};

export default TeacherAssignmentCreateV2;
